import * as React from "react";

interface Props extends React.PropsWithChildren {
  collapsed: boolean;
}
export const VersionWrapper: React.FC<Props> = ({ collapsed, children }) => {
  return collapsed ? null : <>{children}</>;
};
